import React from 'react';
import './WhatsAppButton.css';
import { trackWhatsAppClick } from '../../utils/analytics';

const WhatsAppButton: React.FC = () => {
  const phoneNumber = '94774641111'; // WhatsApp number (country code + number)
  const message = 'Hello! I would like to know more about your smart home products.';
  
  const handleClick = () => {
    // Track conversion
    trackWhatsAppClick(phoneNumber);
    
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="whatsapp-button" onClick={handleClick}>
      <svg 
        viewBox="0 0 32 32" 
        xmlns="http://www.w3.org/2000/svg"
        className="whatsapp-icon"
      >
        <path 
          fill="currentColor" 
          d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-4.713 1.262 1.262-4.669-0.292-0.508c-1.207-2.100-1.847-4.507-1.847-6.123 0-7.435 6.050-13.485 13.485-13.485s13.485 6.050 13.485 13.485-6.050 13.2-13.485 13.2zM21.305 18.421c-0.345-0.171-2.024-0.998-2.339-1.111s-0.542-0.171-0.771 0.171c-0.229 0.342-0.887 1.111-1.087 1.339s-0.4 0.257-0.745 0.086c-0.345-0.171-1.454-0.537-2.770-1.708-1.024-0.913-1.716-2.042-1.916-2.387s-0.021-0.527 0.151-0.697c0.154-0.154 0.345-0.4 0.518-0.6s0.229-0.342 0.345-0.571c0.114-0.229 0.057-0.429-0.029-0.6s-0.771-1.859-1.058-2.548c-0.279-0.671-0.562-0.58-0.771-0.591-0.2-0.010-0.429-0.012-0.658-0.012s-0.6 0.086-0.916 0.429c-0.314 0.343-1.201 1.175-1.201 2.863s1.230 3.321 1.401 3.55c0.171 0.229 2.417 3.691 5.857 5.174 0.818 0.354 1.458 0.566 1.956 0.724 0.822 0.262 1.570 0.225 2.162 0.137 0.659-0.098 2.024-0.828 2.310-1.628s0.286-1.486 0.2-1.628c-0.086-0.142-0.314-0.229-0.658-0.4z"
        />
      </svg>
    </div>
  );
};

export default WhatsAppButton;
